<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <wml-button-one *ngIf="props.verifyBtn.isPresent" [props]="props.verifyBtn"></wml-button-one>
  </section>
  <div *ngIf="props.verifyMsgContainer.isPresent" [class]="classPrefix('Pod1')">
    <i [class]="'fa-solid fa-medal '+ classPrefix('Pod1Icon0')"></i>
    <p [class]="classPrefix('Pod1Text0')">{{props.verifyMsg.text | translate}}</p>
  </div>
</div>
